import { useCallback, useRef } from 'react'

export const useTimer = () => {
  const startTimeRef = useRef(performance.now())
  const elapsedTimeRef = useRef(0)

  const startTimer = useCallback(() => {
    if (startTimeRef.current === null) {
      startTimeRef.current = performance.now()
    }
  }, [])

  const stopTimer = useCallback(() => {
    let totalElapsedTime = elapsedTimeRef.current

    if (startTimeRef.current !== null) {
      const elapsedTime = (performance.now() - startTimeRef.current) / 1000
      totalElapsedTime += elapsedTime
    }

    startTimeRef.current = null
    elapsedTimeRef.current = 0

    return totalElapsedTime
  }, [])

  const pauseTimer = useCallback(() => {
    if (startTimeRef.current !== null) {
      const elapsedTime = (performance.now() - startTimeRef.current) / 1000

      elapsedTimeRef.current += elapsedTime

      startTimeRef.current = null
      return elapsedTime
    }

    return 0
  }, [])

  const resumeTimer = useCallback(() => {
    if (startTimeRef.current === null) {
      startTimeRef.current = performance.now()
    }
  }, [])

  return { startTimer, stopTimer, pauseTimer, resumeTimer }
}
